export enum OrderStatus {
  Received = 'received', // status 22
  Confirmed = 'confirmed', // status 33
  Delivered = 'delivered', // status 66
  Invoiced = 'invoiced', // status 77
  Canceled = 'canceled', // status 99
  Unknown = 'unknown',
}
